/**
 * Single event gateway. analytics.trackEvent already forwards to GA4,
 * dataLayer (when needed) and the internal server sink. Calling gtag here as
 * well used to double-count searches and affiliate clicks.
 */
import { trackEvent as customTrack } from './analytics';

export function trackEvent(eventName, data = {}) {
  try {
    customTrack(eventName, data);
  } catch (err) {
    // Tracking must never interrupt travel searches or partner navigation.
    if (process.env.NODE_ENV === 'development') {
      console.warn('Tracking failed:', err);
    }
  }
}

export const trackSearch = (data) => trackEvent('search', data);
export const trackHotelView = (data) => trackEvent('hotel_view', data);
export const trackBookingClick = (data) => trackEvent('booking_click', data);
